import { render } from "./tag-input.vue?vue&type=template&id=69648ea0&scoped=true"
import script from "./tag-input.vue?vue&type=script&lang=js"
export * from "./tag-input.vue?vue&type=script&lang=js"

import "./tag-input.vue?vue&type=style&index=0&id=69648ea0&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-69648ea0"

export default script